export default "__VITE_ASSET__DNEJJ5PA__"